// eslint-disable-next-line @typescript-eslint/no-var-requires
const routes = require("next-routes-extended")
import { AppSectionEnum } from "../components/types"

const appTabs = Object.values(AppSectionEnum).join("|")
export const defaultRoutes = routes()
    .add("/", "main")
    .add("/index.html", "main")

    .add("/privacy-policy", "privacyPolicy")
    .add("/terms-of-service", "termsOfService")
    .add("/data-deletion", "dataDeletion")

    .add("/verify-email/:email/:code", "cognitoVerifyEmail")
    .add("/reset-password/:email/:code", "cognitoResetPassword")

    .add("/social-login-redirect", "socialLoginRedirect")

    // Without slugs
    .add("/social-login-iframe", "socialLoginIframe")
    .add("/apple-pay-iframe", "applePayIframe")
    .add(`/`, "main")
    .add(`/:tab(${appTabs})?`, "main")
    .add(`/:tab(${AppSectionEnum.Cart})/:paymentStep(payment-option)/:selectedDeliveryType`, "main")
    .add(`/:tab(${AppSectionEnum.Cart})/:paymentStep(finished)`, "main")
    .add(`/:tab(${AppSectionEnum.Cart})/edit/:cartItemId`, "main")
    .add(`/:tab(${AppSectionEnum.Login})`, "main")
    .add(`/:tab(${AppSectionEnum.Login})/:authStep`, "main")
    .add(`/:tab(${AppSectionEnum.Orders})/:orderId`, "main")
    .add(`/:tab(${AppSectionEnum.ProductDetail})/:categorySlug/:productSlug`, "main")

    // With location slug
    .add("/:locationSlug/social-login-iframe", "socialLoginIframe")
    .add("/:locationSlug/apple-pay-iframe", "applePayIframe")
    .add(`/:locationSlug`, "main")
    .add(`/:locationSlug/:tab(${appTabs})?`, "main")
    .add(`/:locationSlug/:tab(${AppSectionEnum.Cart})/:paymentStep(payment-option)/:selectedDeliveryType`, "main")
    .add(`/:locationSlug/:tab(${AppSectionEnum.Cart})/:paymentStep(finished)`, "main")
    .add(`/:locationSlug/:tab(${AppSectionEnum.Cart})/edit/:cartItemId`, "main")
    .add(`/:locationSlug/:tab(${AppSectionEnum.Login})`, "main")
    .add(`/:locationSlug/:tab(${AppSectionEnum.Login})/:authStep`, "main")
    .add(`/:locationSlug/:tab(${AppSectionEnum.Orders})/:orderId`, "main")
    .add(`/:locationSlug/:tab(${AppSectionEnum.ProductDetail})/:categorySlug/:productSlug`, "main")

    // With account + location slug
    .add("/:accountSlug/:locationSlug/social-login-iframe", "socialLoginIframe")
    .add("/:accountSlug/:locationSlug/apple-pay-iframe", "applePayIframe")
    .add(`/:accountSlug/:locationSlug`, "main")
    .add(`/:accountSlug/:locationSlug/:tab(${appTabs})?`, "main")
    .add(
        `/:accountSlug/:locationSlug/:tab(${AppSectionEnum.Cart})/:paymentStep(payment-option)/:selectedDeliveryType`,
        "main"
    )
    .add(`/:accountSlug/:locationSlug/:tab(${AppSectionEnum.Cart})/:paymentStep(finished)`, "main")
    .add(`/:accountSlug/:locationSlug/:tab(${AppSectionEnum.Cart})/edit/:cartItemId`, "main")
    .add(`/:accountSlug/:locationSlug/:tab(${AppSectionEnum.Login})`, "main")
    .add(`/:accountSlug/:locationSlug/:tab(${AppSectionEnum.Login})/:authStep`, "main")
    .add(`/:accountSlug/:locationSlug/:tab(${AppSectionEnum.Orders})/:orderId`, "main")
    .add(`/:accountSlug/:locationSlug/:tab(${AppSectionEnum.ProductDetail})/:categorySlug/:productSlug`, "main")
